function MascotApplication() {

}

MascotApplication.embellishment = "embellishments";
MascotApplication.mascot = "mascot";

MascotApplication.events = {
    isInit: true,

    init: function() {
        var self = this;
        var parent = $("#primary_options_container");

        if (self.isInit) {
            $(parent).on("click", ".application-container .edit-logo", self.onEditMascot);
            $(parent).on("click", ".application-container .flip-logo", self.onFlipMascot);
            $(parent).on("click", ".application-container .create-logo", self.onCreateNewMascot);
            $(parent).on("click", ".application-container .change-mascot-color", self.onChangeMascotColor);
            $(parent).on("click", ".application-container .show-mascot-modal", self.onOpenMascotModal);
            $(parent).on("click", ".application-container .duplicate-logo", self.onDuplicateLogo);

            self.isInit = false;
        }
    },

    onOpenMascotModal: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        if (_.contains(ub.fontGuideIDs, ub.valid) && applicationSettings.application_type === MascotApplication.mascot) {
            ub.funcs.createMascotPopup(null, applicationSettings.mascot, applicationSettings);
        } else {
            ub.data.isEditing = true;
            ub.data.newApplication = applicationSettings;
            InksoftMascot.events.onShowStockMascot();
        }
    },

    onEditMascot: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        if (applicationSettings.application_type === MascotApplication.mascot) {
            if (_.contains(ub.fontGuideIDs, ub.valid)) {
                ub.funcs.createMascotPopup(null, applicationSettings.mascot, applicationSettings);
            } else {
                ub.data.isEditing = true;
                ub.data.newApplication = applicationSettings;
                InksoftMascot.events.onShowStockMascot();
            }
        } else {
            ub.data.isEditing = true;
            var embellishment = applicationSettings.embellishment;
            var conflictingColors = ub.funcs.hasConflict(embellishment.design_details);

            if (conflictingColors._hasConflict) {
                InksoftMascot.funcs.onShowEditDesignConflict(embellishment.design_id, applicationSettings.code, function() {
                    InksoftMascot.uiHandler.renderConflictColors({
                        brand: ub.config.brand.toTitleCase(),
                        colors: conflictingColors._conflictColors
                    });

                    UIkit.modal("#inksoft-design-editor-modal-with-conflict").show();
                });
            } else {
                InksoftMascot.funcs.onShowEditDesignModal(embellishment.design_id, applicationSettings.code, function() {
                    UIkit.modal("#inksoft-design-editor-modal").show();
                });
            }
        }
    },

    onFlipMascot: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        ub.funcs.flipMascot(applicationSettings);
        $(this).toggleClass("uk-active");
    },

    onCreateNewMascot: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        ub.data.isEditing = true;
        ub.data.newApplication = applicationSettings;
        CreateUploadInksoft.events.init(applicationSettings);
    },

    onChangeMascotColor: function() {
        var that = this;
        var container = $(this).closest(".layer-container");
        var layer_number = $(container).data("layer-number");
        var color_code = $(this).data("color-code");
        var color_object = ub.funcs.getColorByColorCode(color_code);
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);

        ApplicationCore.funcs.changeMascotColor(layer_number, color_object, applicationSettings, function() {
            $(container).find("a.uk-active").removeClass("uk-active").html("");
            $(that).addClass("uk-active");
            $(that).html('<span class="fa fa-check fa-1x color-pallete-check" style="color: #'+ color_object.forecolor +'"></span>');
        });
    },
    
    onDuplicateLogo: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        DuplicateApplication.render(applicationSettings);
    }
};

MascotApplication.renderMascot = function(application_id) {
    var applicationSettings = ub.funcs.getApplicationSettings(application_id);

    if (typeof applicationSettings !== "undefined") {
        if (applicationSettings.application_type === MascotApplication.embellishment) {
            if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
                TextApplication.render(applicationSettings.code);
                return;
            }

            var embellishment = applicationSettings.embellishment;
            
            if (ub.funcs.hasConflict(embellishment.design_details)._hasConflict) {
                MascotApplication.renderConflictingColor(applicationSettings);
            } else {
               MascotApplication.render(application_id); 
            }
        } else {
            MascotApplication.render(application_id);
        }
    } else {
        console.log("Cannot Find application")
        return;
    }

    MascotApplication.events.init();
    // Opacity Slider is available in sublimated
    if (ub.funcs.isSublimated()) {
        ApplicationCore.view.opacitySlider(applicationSettings);
    }

    ApplicationCore.funcs.afterRender(applicationSettings);    
}


MascotApplication.render = function(application_id) {
    var utilities = ApplicationCore.utilities;
    var applicationSettings = ub.funcs.getApplicationSettings(application_id);
    var mascot = undefined;

    if (applicationSettings.application_type === MascotApplication.embellishment) {
        var design_id = "";
        var design_name = "";
        var design_image = "";
        var design_svg = undefined;

        if (typeof applicationSettings.embellishment !== "undefined") {
            var design_id = applicationSettings.embellishment.design_id;
            var design_name = typeof applicationSettings.embellishment.name !== "undefined" ? applicationSettings.embellishment.name : applicationSettings.embellishment.design_name;
            var design_image = applicationSettings.embellishment.png_filename;
            var design_svg = applicationSettings.embellishment.svg_filename
        }

        mascot = {
            thumbnail: design_image,
            name: design_name,
            viewArtDetails: ub.config.host + '/utilities/previewEmbellishmentInfo/' + design_id,
            viewPrint: design_svg,
            flip: ApplicationCore.utilities.isFlippedApplication(applicationSettings.code),
            design_id: design_id,
            type: "Custom Mascot"
        }
    } else if (applicationSettings.application_type === MascotApplication.mascot) {
        mascot = {
            thumbnail: applicationSettings.mascot.icon,
            code: applicationSettings.code,
            name: applicationSettings.mascot.name,
            flip: ApplicationCore.utilities.isFlippedApplication(applicationSettings.code),
            type: "Stock Mascot",
            viewPrint: typeof applicationSettings.mascot.ai_file !== "undefined" ? applicationSettings.mascot.ai_file : undefined ,
        };
    }

    ub.funcs.deactivatePanels();

    if (typeof applicationSettings !== "undefined") {
        var tmpl = _.template($("#mascot-application-template").html());

        $(".modifier_main_container").append(tmpl({
            application: applicationSettings,
            colors: ub.current_material.settings.team_colors,
            scale: utilities.computeScale(applicationSettings),
            position: utilities.computePosition(applicationSettings),
            angle: utilities.computeRotation(applicationSettings),
            isSpecial: _.contains(ub.fontGuideIDs, window.ub.valid),
            mascot: mascot
        }));
    } else {
        ub.utilities.warn("Cannot find application setting of code " + application_id);
    }

}

MascotApplication.renderConflictingColor = function(applicationSettings) {
    var tmpl = _.template($("#mascot-conflict-colors").html());
    var embellishment = applicationSettings.embellishment;

    ub.funcs.deactivatePanels();

    if (typeof embellishment !== "undefined") {
        $(".modifier_main_container").append(tmpl({
            brand: ub.config.brand,
            application: applicationSettings,
            conflictingColors: ub.funcs.hasConflict(embellishment.design_details)._conflictColors,
            type: "Custom Mascot"
        }));
    }
}